(function () {
  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");

    let observer;
    const createObserver = () => {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const annBarHeight = annBar?.getBoundingClientRect().height || 0;
              document.documentElement.style.setProperty(
                "--ann-height",
                `${(annBarHeight * entry.intersectionRatio).toFixed(2)}px`
              );
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      if (annBar) observer.observe(annBar);
    };
    createObserver();
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();

if (!customElements.get("announcement-bar-slider")) {
  class AnnouncementBarSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll(".announcement-bar__slide"));
      if (this.slides.length < 2) return;

      this.delay = parseInt(this.dataset.autoplayDelay, 10) || 4000;
      this.index = Math.max(
        this.slides.findIndex((slide) => slide.classList.contains("is-active")),
        0
      );

      // Guard against duplicate listeners if the element is moved and reconnected
      if (!this.initialised) {
        this.querySelector("[data-ann-prev]")?.addEventListener("click", () => this.step(-1));
        this.querySelector("[data-ann-next]")?.addEventListener("click", () => this.step(1));

        // Pause on mouse hover and keyboard focus only, so a tap on mobile doesn't
        // leave the slider paused until the visitor taps elsewhere
        this.addEventListener("pointerenter", (event) => {
          if (event.pointerType === "mouse") this.stop();
        });
        this.addEventListener("pointerleave", (event) => {
          if (event.pointerType === "mouse") this.start();
        });
        this.addEventListener("focusin", (event) => {
          if (event.target.matches(":focus-visible")) this.stop();
        });
        this.addEventListener("focusout", (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });

        this.initialised = true;
      }

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.goTo(this.index + 1), this.delay);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    step(direction) {
      this.goTo(this.index + direction);
      // Restart so the new slide gets a full interval, unless paused by hover/focus
      if (this.timer) this.start();
    }

    goTo(index) {
      const count = this.slides.length;
      this.slides[this.index].classList.remove("is-active");
      this.index = (index + count) % count;
      this.slides[this.index].classList.add("is-active");
    }
  }

  customElements.define("announcement-bar-slider", AnnouncementBarSlider);
}
